import type { ResourceProps } from 'react-admin';
import portaitIcon from '@mui/icons-material/Portrait';
import { type ComponentType, lazy } from 'react';
import { CanAccess } from 'react-admin';
import { resources } from '@repo/c360-ra-components';

const AsyncPageCreate = lazy(() => import('./create'));
const AsyncPageList = lazy(() => import('./list'));
const AsyncPageShow = lazy(() => import('./show'));

const protectedList = () => (
  <CanAccess resource={resources.recurringPayments} action="list">
    <AsyncPageList />
  </CanAccess>
);

export default {
  list: protectedList as ComponentType<any>,
  create: AsyncPageCreate as ComponentType<any>,
  show: AsyncPageShow as ComponentType<any>,
  icon: portaitIcon as ComponentType<any>,
} as ResourceProps;
